<template>
  <div class="contain">
    <!-- 검색 영역 -->
    <div class="search_form" ref="search_form">
      <el-form
        :inline="true"
        :model="searchForm"
        :label-position="$device.large ? `top` : `left`"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row>
          <el-col :sm="6">
            <el-form-item :label="$t('아이디')">
              <el-input v-model="searchForm.accountId" @keyup.enter.native="searchFirstPage" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="6">
            <el-form-item :label="$t('사용자명')">
              <el-input v-model="searchForm.accountNm" @keyup.enter.native="searchFirstPage" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="6">
            <el-form-item :label="$t('사용 가능 여부')">
              <combo
                :data="mainVue.code.useYn"
                :label="$t('전체')"
                :model="searchForm.useYn"
                @change="searchForm.useYn = $event"></combo>
            </el-form-item>
          </el-col>
          <el-col :sm="6">
            <el-form-item :label="$t('만료 여부')">
              <combo
                :data="mainVue.code.nonExpired"
                :label="$t('전체')"
                :model="searchForm.nonExpired"
                @change="searchForm.nonExpired = $event"></combo>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 버튼 -->
    <div class="buttons" ref="buttons">
      <el-button
        v-if="checkAuthActionAccess('UserForCustSearch')"
        :size="size"
        @click="searchFirstPage"
        icon="el-icon-search"
        >{{ $t('검색') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('UserForCustAdd')"
        :size="size"
        @click="add"
        icon="el-icon-circle-plus-outline"
        :disabled="btn.addDisabled"
        >{{ $t('등록') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('UserForCustUp')"
        :size="size"
        @click="up"
        icon="el-icon-edit-outline"
        :disabled="btn.upDisabled"
        >{{ $t('수정') }}</el-button
      >
      <el-button
        v-if="checkAuthActionAccess('UserForCustDel')"
        :size="size"
        @click="del"
        icon="el-icon-remove-outline"
        :disabled="btn.delDisabled"
        >{{ $t('삭제') }}</el-button
      >
    </div>

    <!-- 리스트 -->
    <el-table
      :height="tableHeight"
      ref="table"
      border
      stripe
      highlight-current-row
      tooltip-effect="dark"
      :data="tableData"
      :size="size"
      :empty-text="$t('데이타 없음')"
      @row-click="handleRowClick"
      @select="handleRowChecked"
      @select-all="handleRowChecked"
      @sort-change="handleSortChange">
      <el-table-column
        :label="totalElements.toString()"
        type="index"
        width="55"
        align="center"
        label-class-name="data_cnt"
        :index="indexMethod"></el-table-column>
      <el-table-column type="selection" width="45" align="center"></el-table-column>
      <!-- 정렬은 **서버**가 한다(`sortable="custom"`) — 중첩 열 `store.storeNm` 은 [sortAliases] 가 `storeNm` 으로 옮긴다 -->
      <el-table-column
        :label="$t('매장')"
        prop="store.storeNm"
        min-width="200"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('아이디')"
        prop="accountId"
        min-width="100"
        align="center"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('사용자명')"
        prop="accountNm"
        min-width="100"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('핸드폰 번호')"
        prop="tel"
        :formatter="util.telCell"
        min-width="110"
        align="center"></el-table-column>
      <el-table-column :label="$t('이메일')" prop="email" min-width="150" show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('최종 로그인 시간')"
        prop="lastLoginDtm"
        min-width="120"
        align="center"
        sortable="custom"
        show-overflow-tooltip></el-table-column>
      <el-table-column
        :label="$t('사용 가능 여부')"
        prop="useYn"
        min-width="110"
        align="center"
        :formatter="mainVue.formatterCode"></el-table-column>
      <el-table-column
        :label="$t('만료 여부')"
        prop="nonExpired"
        min-width="100"
        align="center"
        :formatter="mainVue.formatterCode"></el-table-column>
    </el-table>
    <list-pagination
      :search-form="searchForm"
      :total="totalElements"
      @page-change="handlePageChange"
      @size-change="handleSizeChange"></list-pagination>

    <!-- 입력 팝업 -->
    <el-dialog :title="inputForm.title" :visible.sync="dialogFormVisible" fullscreen>
      <el-form
        :model="inputForm"
        :label-width="$device.mobile ? `` : `120px`"
        :label-position="$device.mobile ? 'top' : 'left'"
        label-suffix=":"
        :size="size"
        @submit.native.prevent>
        <el-row>
          <el-col :md="12">
            <el-form-item :label="$t('매장')" :error="formError['store.storeCd']" required>
              <!--
                이 칸은 **기본값이 없던 자리**다(계정을 발급할 매장은 사람이 고른다) — 그 동작을 지킨다.
                후보가 하나뿐일 때만 칸이 그 하나를 값으로 세운다(고를 다른 것이 없다).
              -->
              <StorePicker
                v-if="'I' === inputForm.statu"
                v-model="inputForm.store.storeCd"
                :options="store"
                :auto-select="false" />
              <span v-else class="show_cd">{{ inputForm.store.storeNm }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :md="12">
            <el-form-item :label="$t('아이디')" :error="formError.accountId" required>
              <el-input
                v-model="inputForm.accountId"
                maxlength="50"
                clearable
                v-if="'I' === inputForm.statu"
                show-word-limit></el-input>
              <span v-else class="show_cd">{{ inputForm.accountId }}</span>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('사용자명')" :error="formError.accountNm" required>
              <el-input v-model="inputForm.accountNm" maxlength="50" clearable show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <!-- 「비밀번호를 안 바꾼다」는 **빈칸**이다 — 서버가 준 해시를 되돌려 보내지 않는다(보안 원장 ⑥).
               판정과 문구는 `utils/accountPassword` 한 곳이고, 생성에서만 필수다 -->
          <el-col :md="12">
            <el-form-item :label="$t('비밀번호')" :error="formError.accountPw" :required="passwordRequired">
              <el-input v-model="inputForm.accountPw" maxlength="20" type="password" clearable></el-input>
              <div v-if="!passwordRequired" class="account-password-hint">{{ passwordText.keepHint }}</div>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('비밀번호 확인')" :error="formError.accountPwConfirm" :required="passwordRequired">
              <el-input v-model="inputForm.accountPwConfirm" maxlength="20" type="password" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('핸드폰 번호')" :error="formError.tel" required>
              <el-input
                v-keep-number-caret
                :value="util.telFieldText(inputForm.tel)"
                maxlength="20"
                clearable
                show-word-limit
                @input="inputForm.tel = util.telDigits($event)"></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('이메일')" :error="formError.email" required>
              <el-input v-model="inputForm.email" maxlength="100" clearable show-word-limit></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('사용 가능 여부')" required>
              <combo :data="mainVue.code.useYn" :model="inputForm.useYn" @change="inputForm.useYn = $event"></combo>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item :label="$t('만료 여부')" required>
              <combo
                :data="mainVue.code.nonExpired"
                :model="inputForm.nonExpired"
                @change="inputForm.nonExpired = $event"></combo>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button icon="el-icon-check" :size="size" @click="save" :disabled="btn.saveDisabled">{{
          $t('저장')
        }}</el-button>
        <el-button icon="el-icon-close" :size="size" @click="closeDialogVisible = true">{{ $t('닫기') }}</el-button>
        <el-dialog
          title="Warning"
          :visible.sync="closeDialogVisible"
          width="300px"
          :modal="false"
          :modal-append-to-body="false"
          :append-to-body="true"
          center>
          <span>정말로 페이지를 닫으시겠습니까?</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialogVisible = false">아니요</el-button>
            <el-button
              type="primary"
              @click="
                closeDialogVisible = false
                dialogFormVisible = false
              "
              >예</el-button
            >
          </span>
        </el-dialog>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 대리점
import StorePicker from '@/components/store/StorePicker.vue'
import mainVueMixin from '@/mixins/mainVueMixin'
import pagedListMixin from '@/mixins/pagedListMixin'
import { PASSWORD_TEXT, blankPassword, passwordPatch } from '@/utils/accountPassword'
import { initData } from '@/utils/constants'
import { withPaging } from '@/utils/pagedList'
import { STORE_OPTIONS_API, storeOptionsOf, storeOptionsQuery } from '@/utils/storeOptions'

/** 중첩 값을 그리는 정렬 열의 `prop` → 서버 `sortProp` */
const SORT_ALIASES = Object.freeze({ 'store.storeNm': 'storeNm' })

export default {
  components: { StorePicker },

  mixins: [mainVueMixin, pagedListMixin],
  data: function () {
    var data = initData()
    data.url = '/userCust'
    data.store = []

    data.searchForm = this.initSearchForm()
    data.inputForm = this.initInputForm()
    data.formError = this.initFormError()
    /** 비밀번호 축의 문구 — 판정과 같은 파일이 소유한다(`utils/accountPassword`) */
    data.passwordText = PASSWORD_TEXT

    data.closeDialogVisible = false
    return data
  },
  computed: {
    /** 비밀번호가 **필수인가** — 생성에서만 그렇다. 수정의 빈칸은 「그대로 둔다」는 뜻이다 */
    passwordRequired: function () {
      return 'I' === this.inputForm.statu
    },
    /** 중첩 열의 정렬 축 — 기본 `{}` 를 주는 [pagedListMixin] 의 같은 이름을 덮어쓴다 */
    sortAliases: function () {
      return SORT_ALIASES
    },
  },
  created: function () {
    this.initStore()
    this.search()
  },
  mounted: function () {
    setTimeout(
      function () {
        this.$nextTick(
          function () {
            this.mainVue.currVue = this
          }.bind(this)
        )
      }.bind(this),
      500
    )
  },
  watch: {
    'inputForm.accountId': function (newVal, oldVal) {
      if ('' != newVal && 'I' === this.inputForm.statu) {
        this.chkAccountId()
      }
    },
  },
  methods: {
    // 검색 조건 초기화 — 페이징·정렬 축은 [withPaging] 이 붙인다(기본 50건·첫 페이지·서버 기본 정렬)
    initSearchForm: function () {
      return withPaging({
        accountId: '',
        accountNm: '',
        useYn: 'Y',
        nonExpired: '',
      })
    },
    // 입력폼 초기화
    initInputForm: function () {
      return {
        statu: 'I',
        title: '',
        accountId: '',
        accountNm: '',
        accountPw: '',
        accountPwConfirm: '',
        useYn: 'Y',
        nonExpired: 'Y',
        tel: '',
        email: '',
        store: { storeCd: null, storeNm: '' },
      }
    },
    // 오류 메세지 초기화
    initFormError: function () {
      return {
        accountId: '',
        accountNm: '',
        accountPw: '',
        accountPwConfirm: '',
        tel: '',
        email: '',
        'store.storeCd': '',
      }
    },
    // 그리드 선택 이벤트
    handleRowClick: function (val) {
      if (null != val) {
        this.btn.upDisabled = false
      }

      this.selectData = val
    },
    // 체크 박스 체크 이벤트
    handleRowChecked: function (selection, row) {
      if (selection.length > 0) {
        this.btn.delDisabled = false
      } else {
        this.btn.delDisabled = true
      }

      this.checkedData = []

      for (var i = 0, len = selection.length; i < len; i++) {
        this.checkedData[this.checkedData.length] = selection[i].accountId
      }
    },
    // 매장 자동 검색 — 셀렉트 전용 경량 조회다. URL·조건은 [storeOptionsQuery] 한 곳이 소유한다
    initStore: function () {
      this.mainVue.$axios.search(
        STORE_OPTIONS_API,
        storeOptionsQuery(),
        function (result) {
          this.store = storeOptionsOf(result)
        }.bind(this)
      )
    },
    // 추가
    add: function () {
      this.inputForm = this.initInputForm()
      this.inputForm.title = this.$t('매장 회원 추가')

      this.formError = this.initFormError()

      this.dialogFormVisible = true
      this.btn.saveDisabled = false
    },
    /** 수정 — 비밀번호 두 칸은 **언제나 빈칸**으로 연다([blankPassword], 보안 원장 ⑥) */
    up: function () {
      this.mainVue.$axios.get(
        this.url + '/' + this.selectData.accountId,
        function (result) {
          this.inputForm = Object.assign({}, result, blankPassword(), {
            statu: 'U',
            title: this.$t('매장 회원 수정'),
          })

          this.formError = this.initFormError()

          this.dialogFormVisible = true
          this.btn.saveDisabled = false
        }.bind(this),
        true
      )
    },
    // 조회
    search: function () {
      this.mainVue.$axios.search(
        this.url,
        this.searchQuery(),
        function (result) {
          this.applyPage(result)

          this.btn.addDisabled = false
          this.btn.upDisabled = true
          this.btn.delDisabled = true

          this.inputForm = this.initInputForm()
          this.formError = this.initFormError()
        }.bind(this),
        false
      )
    },
    // 삭제
    del: function () {
      this.mainVue
        .$confirm(this.$t('매장 회원 정보를 삭제 하시겠습니까?'), this.mainVue.appMsg.systemAlterTitle, {
          confirmButtonText: this.$t('삭제'),
          cancelButtonText: this.$t('취소'),
          type: 'info',
        })
        .then(
          function () {
            this.mainVue.$axios.del(
              this.url + '/' + this.checkedData.join(','),
              function (result) {
                this.mainVue.$message({ type: 'success', message: this.$t('삭제 성공') })
                this.search()
              }.bind(this),
              true
            )
          }.bind(this)
        )
        .catch(
          function () {
            this.mainVue.$message({ type: 'info', message: this.$t('삭제 취소') })
          }.bind(this)
        )
    },
    /** 저장 — 비밀번호 축의 판정은 [passwordPatch] 한 곳이다(빈칸이면 두 키를 본문에서 뺀다) */
    save: function () {
      this.formError = this.initFormError()

      const patch = passwordPatch(this.inputForm)

      if (!patch.ok) {
        this.formError[patch.field] = this.$t(patch.message)

        return
      }

      if ('I' === this.inputForm.statu) {
        this.mainVue.$axios.add(
          this.url,
          patch.payload,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('등록 성공') })
            this.dialogFormVisible = false
            this.search()
          }.bind(this),
          true
        )
      } else {
        this.mainVue.$axios.up(
          this.url + '/' + this.inputForm.accountId,
          patch.payload,
          this.formError,
          function (result) {
            this.mainVue.$message({ type: 'success', message: this.$t('수정 성공') })
            this.dialogFormVisible = false
            this.search()
          }.bind(this),
          true
        )
      }
    },
    // 계정 아이디 체크
    chkAccountId: function () {
      this.mainVue.$axios.patchNonLoading(
        '/account/chk/' + this.inputForm.accountId,
        null,
        null,
        function (result) {
          if ('' == result) {
            this.formError.accountId = ''
            this.btn.saveDisabled = false
          } else {
            this.formError.accountId = this.$t('이미 사용중인 아이디입니다.')
            this.btn.saveDisabled = true
          }
        }.bind(this),
        false
      )
    },
  },
}
</script>
